import React, { ReactNode } from 'react';

import { Checkbox, CheckboxProps, FormControlLabel, SxProps } from '@mui/material';
import { Field, FieldProps } from 'formik';

export interface CheckBoxFieldProps extends Omit<CheckboxProps, 'value'> {
	label?: ReactNode;
	name: string;
	value?: any;
	multiple?: boolean;
	onValueChange?: (value: any) => void;
	labelStyles?: SxProps;
	typographyStyles?: SxProps;
	readOnly?: boolean;
}

export default function CheckBoxField({
	label,
	name,
	value,
	multiple = false,
	onValueChange,
	labelStyles,
	typographyStyles,
	readOnly = false,
	...props
}: CheckBoxFieldProps) {
	return (
		<Field name={name}>
			{({ field, form }: FieldProps) => {
				const fieldValue = field.value;

				const isChecked = multiple
					? Array.isArray(fieldValue) && fieldValue.includes(value)
					: !!fieldValue;

				const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
					if (readOnly) return;

					let newValue;

					if (multiple) {
						newValue = Array.isArray(field.value) ? [...field.value] : [];

						if (event.target.checked) {
							newValue.push(value);
						} else {
							newValue = newValue.filter((v) => v !== value);
						}
					} else {
						newValue = event.target.checked ? 1 : 0;
					}

					form.setFieldValue(name, newValue);
					onValueChange?.(newValue);
				};

				return (
					<FormControlLabel
						componentsProps={{ typography: { sx: { ...typographyStyles } } }}
						sx={{ ...labelStyles }}
						control={<Checkbox checked={isChecked} onChange={handleChange} {...props} />}
						label={label}
					/>
				);
			}}
		</Field>
	);
}
